module.exports = __webpack_public_path__ + "img/Expo_TopicA5.f6fce461.png";